import { LineChartDataItem } from '@src/features/company/dx-diagnosis/DxDiagnosisResultForm';
import {
  ActiveElement,
  CategoryScale,
  Chart,
  Chart as ChartJS,
  Legend,
  LinearScale,
  LineElement,
  PointElement,
  Title,
  Tooltip,
} from 'chart.js';
import { Line } from 'react-chartjs-2';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend);

const TransitionGraphChartjs = ({ data }: { data: LineChartDataItem }) => {
  // グラフのオプション設定
  const options = {
    responsive: true,
    maintainAspectRatio: false, // アスペクト比を維持
    aspectRatio: 3, // アスペクト比
    scales: {
      // 折れ線グラフの線などの設定
      x: {
        offset: true,
        min: 0,
        max: 1000, // 最小表示数を設定
        ticks: {
          font: {
            size: 14, // フォントサイズ
          },
          callback: (_value: unknown, index: number) => {
            const originalDate = data.labels[index];
            if (!originalDate) {
              return '';
            }
            const date = new Date(originalDate);
            return isNaN(date.getTime())
              ? ''
              : `${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
          },
        },
        grid: {
          color: '#E4E4E4', // X軸のグリッド線の色
          borderColor: 'red', // X軸の軸線の色
        },
      },
      y: {
        offset: true,
        min: 0,
        max: 120,
        ticks: {
          // stepSize: 2,
          callback: (value: unknown) => {
            return Math.floor(value as number);
          },
          font: {
            size: 10,
          },
        },
        grid: {
          color: '#E4E4E4', // Y軸のグリッド線の色
          borderColor: 'red', // Y軸の軸線の色
        },
      },
    },
    elements: {
      point: {
        hoverRadius: 7,
        borderWidth: 2,
        hoverBorderWidth: 2,
        borderColor: undefined, // 線の色を使用
        pointStyle: 'circle',
        hoverBackgroundColor: 'white',
      },
    },
    plugins: {
      tooltip: {
        backgroundColor: '#fff', // ツールチップの背景色
        titleColor: '#292929', // タイトルの文字色
        titleFont: {
          // タイトルのフォント設定
          size: 11,
        },
        bodyColor: '#292929', // 本文の文字色
        bodyFont: {
          // 本文のフォント設定
          size: 14,
        },
        borderColor: '#E4E4E4', // ボーダーの色
        borderWidth: 1, // ボーダーの太さ
        padding: 13, // 内側の余白
        cornerRadius: 6, // 角の丸み
        displayColors: false, // カラーボックスの表示/非表示
        usePointStyle: true,
        callbacks: {
          title: (context: unknown[]) => {
            const ctx = context as { label: string }[];
            return `診断完了日：${ctx[0].label}`;
          },
          label: (context: unknown) => {
            const ctx = context as {
              dataset: { data: { y: number; name: string }[] };
              dataIndex: number;
            };
            const dataPoint = ctx.dataset.data[ctx.dataIndex];
            return [`総合スコア：${dataPoint.y}`, `回答者：${dataPoint.name}`];
          },
        },
      },
      legend: {
        display: false, // 凡例を非表示
      },
    },
    onClick: (_event: unknown, elements: ActiveElement[], chart: Chart) => {
      if (elements.length > 0) {
        const activeElement = elements[0];
        const datasetIndex = activeElement.datasetIndex;
        const dataset = chart.data.datasets[datasetIndex];
        chart.data.datasets.forEach((ds) => {
          ds.borderWidth = 1;
        });
        dataset.borderWidth = 3;
        chart.update();
      }
    },
  };

  return (
    <div>
      <Line
        options={options}
        data={data}
      />
    </div>
  );
};

export default TransitionGraphChartjs;
